export default __webpack_public_path__ + "static/media/spark_87.adc37575.png";